import { resetarParaEstadoInicial } from 'src/utils/executoras/executoras'

import {
  vuexMapDefaultsMutations,
  vuexMapDefaultsActions
} from 'src/utils.store'

import { multiSelect } from 'src/common/selectors'

function defaultState () {
  return {
    ...multiSelect.mapStates(['companies', 'employees', 'userGroups', 'employers']),
    startDate: null,
    endDate: null,
    type: 'employee',
    acionadoPelaHome: false,
    categoriaAcionadaPelaHome: null
  }
}

const state = defaultState()

const mutations = {
  ...multiSelect.mapMutations(['companies', 'employees', 'userGroups', 'employers']),
  ...vuexMapDefaultsMutations(defaultState()),
  resetState: state => {
    const toBe = defaultState()
    delete toBe['companies']
    delete toBe['employees']
    delete toBe['userGroups']
    delete toBe['employers']
    resetarParaEstadoInicial(state, toBe)
    state.companies.selected = []
    state.employees.selected = []
    state.userGroups.selected = []
    state.employers.selected = []
  }
}

const actions = {
  ...vuexMapDefaultsActions(defaultState())
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
